module.exports = __webpack_public_path__ + "static/laumusic3-0f849f8712edff9b38bc964a6e7b2c72.jpg";